module.exports = __webpack_public_path__ + "images/category_lp/camera/SONY-FE-90mm-F2.8-Macro-G-OSS-SEL90M28G_41a7b19334c771f543072d5e082b7d3f.png";